import classnames from 'classnames';

const OverlayButtons = ({ overlay }) => {
    const { contentParams } = overlay;

    const classes = classnames('overlay-buttons', contentParams.theme, contentParams.className);

    return (
        <div className={classes}>
            <div className="overlay-buttons__content">
                {contentParams.buttons ? (
                    <>
                        {contentParams.buttons.map((button, index) => {
                            return (
                                <a className={`overlay-buttons__button ${button.className ? button.className : ''}`} href={button.link} target={button.target} key={index}>
                                    {button.text}
                                </a>
                            )
                        })}
                    </>
                ) : null}
            </div>
        </div>
    )
}

export default OverlayButtons
